import { useSpecificLockerActionContext } from "../../contexts/SpecificLockerActionContext";
import { FavouriteLockerType, LocalStorageFavouriteLocker, Locker } from "../../data/LockerDataTypes";
import { BriefCase, ClockIcon, FavouriteLockerHeart as FavouriteLockerHeart, HouseHeart } from "../Miscellaneous";

export interface LockerItemIconProps {
    locker: Locker
}

interface FavouriteLockerIconProps {
    favouriteLocker: LocalStorageFavouriteLocker,
}

const FavouriteUnknownLockerIcon = (
    <div className="locker-plugin-fav-heart-in-list">
        <FavouriteLockerHeart />
    </div>
);

const FavouriteHomeLockerIcon = (
    <div className="locker-plugin-fav-heart-in-list">
        <HouseHeart />
    </div>
);

const FavouriteWorkLockerIcon = (
    <div className="locker-plugin-fav-heart-in-list">
        <BriefCase />
    </div>
);

const FavouriteLockerIcon = ({ favouriteLocker }: FavouriteLockerIconProps): JSX.Element => {
    switch (favouriteLocker.type) {
        case FavouriteLockerType.Unknown:
        default:
            return FavouriteUnknownLockerIcon;
        case FavouriteLockerType.Home: return FavouriteHomeLockerIcon;
        case FavouriteLockerType.Work: return FavouriteWorkLockerIcon;
    }
}

const PreviousLockerIcon = () => {
    return (
        <div className="locker-plugin-clock-in-list">
            <ClockIcon />
        </div>
    );
};


function LockerItemIcon({ locker }: LockerItemIconProps) {
    const { favouriteLockers, previouslyUsedLockers } = useSpecificLockerActionContext();

    const favouriteLocker: LocalStorageFavouriteLocker | undefined = favouriteLockers?.find(x => x.lockerId == locker.lockerId);
    const isPreviouslyUsedLocker : boolean = !favouriteLocker && !!previouslyUsedLockers?.find(x => x.lockerId == locker.lockerId);

    return <>
        {favouriteLocker && <FavouriteLockerIcon favouriteLocker={favouriteLocker} />}
        {isPreviouslyUsedLocker && <PreviousLockerIcon />}
    </>;
}

export default LockerItemIcon;